import { createSelector } from '@app/utils/createSelector'
import { trimRegionalRoute } from '@app/utils/routing/region'

import type { Selector } from '@app/store/store'

import { availableRegionsSlugsSelector } from './regions'

export type LandingVersion = 'main' | 'urgent_nanny' | 'part_time_nanny' | 'coolest' | 'safety' | 'nanny' | 'camp' | 'online'

/**
 * Site view, whether it pointed on sitters or on parents.
 * One edge case is "parent-nanny" that is "/nanny" landing version
 */
export const createLandingVersionSelector = (pathnameSelector: Selector<string>) =>
  createSelector([availableRegionsSlugsSelector, pathnameSelector], (regions, pathname): LandingVersion => {
    const path = trimRegionalRoute(regions, pathname).substring(1)
    switch (path) {
      case 'urgent-nanny':
        return 'urgent_nanny'
      case 'part-time-nanny':
        return 'part_time_nanny'
      case 'safety':
        return 'safety'
      case 'nanny':
        return 'nanny'
      case 'camp':
        return 'camp'
      case 'online':
        return 'online'
      default:
        return 'main'
    }
  })
